import type { CheckboxChangeEventType } from '../checkbox/checkbox';
import { Checkbox } from '../checkbox/checkbox';

export interface ActionSectionItem {
  value: unknown;
  text: string;
  selected?: boolean;
}

export interface DropDownActionSectionProps {
  items: Array<ActionSectionItem>;
  onItemChanged: (value: ActionSectionItem) => void;
}

const DropDownActionSection = ({ items, onItemChanged }: DropDownActionSectionProps) => {
  const handleOnChange = (value?: CheckboxChangeEventType) => {
    if (value) {
      onItemChanged({
        value: value.name,
        text: value.value as string,
        selected: value.checked,
      });
    }
  };

  return (
    <div className="w-full flex text-sm flex-col">
      {items.map((item) => (
        <Checkbox
          key={`action_${item.value}`}
          name={item.value as string}
          value={item.text}
          checked={item.selected}
          label={item.text}
          onChange={handleOnChange}
        />
      ))}
    </div>
  );
};

export { DropDownActionSection };
